function isObjectEmpty (obj: object): boolean {
  if (Object.getOwnPropertyNames) {
    return (Object.getOwnPropertyNames(obj).length === 0)
  } else {
    for (let key in obj) {
      if (hasOwnProp(obj, key)) {
        return false
      }
    }
    return true
  }
}

function isObject (input: any): boolean {
  // IE8 will treat undefined and null as object if it wasn't for
  // input != null
  return input != null && Object.prototype.toString.call(input) === '[object Object]'
}

function isArray (input: any): boolean {
  return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]'
}

function isFunction (input: any): boolean {
  return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]'
}

function isNumber (input: any): boolean {
  return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]'
}

function isDate (input: any): boolean {
  return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]'
}

function isUndefined (input: any): boolean {
  return input === void 0
}

function hasOwnProp (object: object, prop: string): boolean {
  return object.hasOwnProperty(prop) || Object.prototype.hasOwnProperty.call(object, prop)
}

function hasArray (input: any): number {
  return isArray(input) ? input.length : 0
}

/**
 * Formates file size.
 *
 * @param {Number} size
 */
function formatFileSize (size: number): string {
  const units = ['Byte', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
  const threshold = 1024
  size = Number(size) * threshold
  const i = size === 0 ? 0 : Math.floor(Math.log(size) / Math.log(threshold))
  return `${(size / Math.pow(threshold, i)).toFixed(2)} ${units[i]}`
}

/**
 * Convert String to UpperCase
 * 
 * @param {string} input
 */
function upperCase (input: string): string {
  return input.toLocaleUpperCase()
}

/**
 * Convert String to LowerCase
 * 
 * @param {string} input
 */
function lowerCase (input: string): string {
  return input.toLocaleLowerCase()
}

/**
 * Convert String to Capitalize Case.
 * 
 * @param {string} input
 */
function capitalize (input: string): string {
  return `${upperCase(input.charAt(0))}${input.slice(1)}`
}

export {
  hasArray,
  hasOwnProp,
  isObjectEmpty,
  isObject,
  isArray,
  isDate,
  isNumber,
  isFunction,
  isUndefined,
  formatFileSize,
  upperCase,
  lowerCase,
  capitalize
}